import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 66 66"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { style: {"animation":"rotator 1.4s linear infinite","transform-origin":"center"} }, [
      _createElementVNode("circle", {
        cx: "33",
        cy: "33",
        r: "30",
        style: {"animation":"dash 1.4s ease-in-out infinite","fill":"none","stroke":"currentcolor","stroke-dasharray":"187","stroke-dashoffset":"0","stroke-linecap":"round","stroke-width":"6","transform-origin":"center"}
      })
    ], -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "loader"}) } }